// Utility functions
export const escapeHtml = (unsafe) =>
  unsafe
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");

export const truncateWithTooltip = (value, maxLength = 200) => {
  if (value.length <= maxLength) return value;

  const truncated = value.substring(0, maxLength) + "...";
  return `<div data-hover-text="${escapeHtml(value)}">${escapeHtml(truncated)}</div>`;
};

export const formatLabel = (key: string) => {
  return key
    .replace(/_/g, ' ')
    .replace(/\b\w/g, char => char.toUpperCase())
}

export const getMultiselectOptions = (options = [], fullLabel = false) => {
  const res = [];

  if (typeof options[0] === 'object' && options[0] !== null && !Array.isArray(options[0])) {
    options
      .sort((a, b) => a.title.localeCompare(b.title)) // Ensure sorting is safe
      .forEach(option => {
        const title = fullLabel ? option.title : option.title.split(/:| - /)[0]
        res.push({ label: formatLabel(title), value: option.id });
      });
  } else {
    options.forEach(option => {
      res.push({ label: formatLabel(option), value: option });
    });
  }

  return res;
};

type TGetHighlightStyleParams = {
  blockChangeHighlight: BlockChangeHighlight;
  editingContext: EditingContext;
  forRow?: boolean;
};

// Highlight marker for DELETE_CONTENT and ADD_CONTENT
export const getHighlightStyle = ({
  blockChangeHighlight,
  editingContext,
  forRow = false,
}: TGetHighlightStyleParams) => {
  if (!blockChangeHighlight) return {};
  const { type, author_id } = blockChangeHighlight;
  const baseStyle = {
    textDecoration: type === "DELETE_CONTENT" ? "line-through" : undefined,
    textDecorationColor:
      type === "DELETE_CONTENT"
        ? `rgb(${editingContext.colorLookup[author_id] || [255,0,0]})`
        : undefined,
    color:
      type === "ADD_CONTENT"
        ? `rgb(${editingContext.colorLookup[author_id] || [255,0,0]})`
        : undefined,
  };

  if (type === "DELETE_CONTENT" && forRow) {
    return {
      ...baseStyle,
      border: "2px solid red",
    };
  }

  return baseStyle;
};

// Helper to decode HTML entities
export function decodeHTMLEntities(text: string): string {
  const txt = typeof window !== 'undefined' ? document.createElement('textarea') : null;
  if (!txt) return text;
  txt.innerHTML = text;
  return txt.value;
}
